import Spin from '@/components/basic/spin';
import theme from '@/style';
import React from 'react';
import {FlatList, View} from 'react-native';
import {getMatkaLastOrder, getMatkaResultList} from '../result-service';
import {MatkaOrder, MatkaResultItem, MatkaTypeItem} from '../result.type';
import ListItem from './list-item';
import useInfiniteScroll from '@/common-pages/hooks/load-more.hooks';
import MatkaDraw from './draw';
import NoData from '@/components/basic/error-pages/no-data';
import {StyleSheet} from 'react-native';
import globalStore from '@/services/global.state';

const MatkaResult = ({
  matkaType = [],
  isActive,
  lotteryType,
}: {
  matkaType?: MatkaTypeItem[];
  isActive?: boolean;
  lotteryType?: string;
}) => {
  const [loading, setLoading] = React.useState(true);
  const [list, setList] = React.useState<MatkaResultItem[]>([]);
  const [order, setOrder] = React.useState<MatkaOrder>();
  const {onEndReachedCalledDuringMomentum} = useInfiniteScroll('result-matka');
  const currentPage = React.useRef(1);
  const hasMores = React.useRef(true);
  const listRef = React.useRef<MatkaResultItem[]>([]);
  const pageSize = 10;

  const getOrder = async () => {
    try {
      const res = await getMatkaLastOrder();
      setOrder(res);
    } finally {
    }
  };

  const getList = async (page = 1, loadMore = false) => {
    try {
      if (!loadMore) {
        setLoading(true);
      }
      const searchId = matkaType.find(item => item.lotteryName === lotteryType);
      const res = await getMatkaResultList(
        page,
        pageSize,
        searchId?.matkaId || 0,
      );
      hasMores.current = page < (res?.totalPages || 0);
      const content = res?.content || [];
      const nextList = loadMore ? listRef.current.concat(content) : content;
      listRef.current = nextList;
      setList(nextList);
    } finally {
      setLoading(false);
      onEndReachedCalledDuringMomentum.current = true;
    }
  };

  React.useEffect(() => {
    if (isActive) {
      currentPage.current = 1;
      hasMores.current = true;
      listRef.current = [];
      getList();
      if (globalStore.token) {
        getOrder();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotteryType, isActive]);

  const onLoadMore = async () => {
    if (hasMores.current && !onEndReachedCalledDuringMomentum.current) {
      currentPage.current += 1;
      await getList(currentPage.current, true);
    }
  };

  return (
    <Spin loading={loading} style={[theme.flex.flex1]}>
      <FlatList
        ListHeaderComponent={
          !loading && isActive && order?.orderNo ? (
            <MatkaDraw order={order} />
          ) : null
        }
        ListEmptyComponent={!loading && isActive ? <NoData /> : null}
        ListFooterComponent={<View style={styles.footerSpacer} />}
        id="result-matka"
        scrollEventThrottle={16}
        onEndReachedThreshold={0.1}
        onMomentumScrollBegin={() => {
          onEndReachedCalledDuringMomentum.current = false;
        }}
        onEndReached={onLoadMore}
        contentContainerStyle={styles.content}
        keyExtractor={item => item.issueNo}
        data={list}
        renderItem={({item}) => <ListItem {...item} />}
      />
    </Spin>
  );
};

const styles = StyleSheet.create({
  content: {
    padding: 12,
    rowGap: 12,
  },
  footerSpacer: {
    height: 72,
  },
});

export default MatkaResult;
